// @flow

import React, { Component } from 'react';

import './ContactInfo.css';


export default class ContactInfo extends Component {

    render () {
        return (
            <div
                className="ln-contact-info">

                <div
                    className="ln-contact-info-text">

                    Jeśli interesuje cię jeden z moich wzorów, masz pytania dotyczące
                    licencji i współpracy lub chcesz się ze mną skontaktować,
                    napisz na <b>kasia@lauranor.com</b>. Z radością odpowiem na każde pytanie.
                </div>

            </div>)
    }
}



// WEBPACK FOOTER //
// ./src/components/ContactInfo/ContactInfo.js